export default __webpack_public_path__ + "media/images/map/leaflet/images/layers-416d91365b44e4b4f4777663e6f009f3.png";